var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___Mi1COU",
  "r9": "Checkbox.module__disabled___Mi1COU",
  "iD": "Checkbox.module__menuDisabled___Mi1COU",
  "kv": "Checkbox.module__checkbox___Mi1COU",
  "aP": "Checkbox.module__box___Mi1COU",
  "LI": "Checkbox.module__round___Mi1COU",
  "KD": "Checkbox.module__checked___Mi1COU",
  "NX": "Checkbox.module__checkedInverted___Mi1COU",
  "e_": "Checkbox.module__inverted___Mi1COU",
  "oE": "Checkbox.module__checkIcon___Mi1COU",
  "HN": "Checkbox.module__invertedIcon___Mi1COU",
  "Pf": "Checkbox.module__label___Mi1COU",
  "hJ": "Checkbox.module__labelInteractive___Mi1COU",
  "QK": "Checkbox.module__labelText___Mi1COU",
  "GR": "Checkbox.module__keyboardShortcut___Mi1COU",
  "RA": "Checkbox.module__keyboardShortcutKey___Mi1COU",
  "wf": "Checkbox.module__keyboardShortcutLabel___Mi1COU",
  "xB": "Checkbox.module__keyboardShortcutHint___Mi1COU",
  "wP": "Checkbox.module__keyboardShortcutPortal___Mi1COU",
  "nV": "Checkbox.module__labelFocusRing___Mi1COU",
  "P8": "Checkbox.module__menuChecked___Mi1COU",
  "fb": "Checkbox.module__checkboxIndicator___Mi1COU",
};

module.exports = exports;
